import './Image.css'

const Image = props => {
    return <div className="container fluid py-2" id="image">
        <div className="container fluid">
            <p className="text xl"><a href="#image" className="link">&#128279;</a> Image</p>
            <p className="text md">
                <code>.responsive-image</code> class applies <code>width: 100%; height: auto;</code> to a
                            <code>img</code> element or any other HTML element.
                        </p>
        </div>

        <div className="spacer md"></div>

        <div className="container lg">
            <div className="table" padding="1" cell-spacing="1" cell-border="1" table-striped="true">
                <table>
                    <thead>
                        <tr>
                            <th>Class</th>
                            <th>Description</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <code>.responsive-image</code>
                            </td>
                            <td>Applied to an <code>img</code> tag will force the image to be responsive</td>
                        </tr>
                        <tr>
                            <td>
                                <code>.wrapped-image</code>
                            </td>
                            <td>Applied to an <code>img</code> tag will force the image to wrap to parent container</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div className="container sm my-1">
            <div className="form-item lg">
                <label>Change the size of the container</label>
                <select onChange={(e) => props.helper(['responsive-image-display', 'wrapped-image-display'], null, `border-dark p-1 mt-1`, e)}>
                    <option defaultValue>select a value</option>
                    <option value="img_container sm">sm</option>
                    <option value="img_container md">md</option>
                    <option value="img_container lg">lg</option>
                    <option value="img_container xl">xl</option>
                </select>
            </div>
        </div>

        <div className="justify-content-center">
            <span className="badge md">RESPONSIVE-IMAGE</span>
        </div>
        <div className="img_container sm border-dark p-1 mt-1" id="responsive-image-display">
            <img src='https://images.pexels.com/photos/546819/pexels-photo-546819.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260' alt="POKE-CSS-LOGO" className="responsive-image" />

        </div>

        <div className="spacer sm"></div>

        <div className="justify-content-center">
            <span className="badge md">WRAPPED-IMAGE</span>
        </div>
        <div className="img_container sm border-dark p-1 mt-1" id="wrapped-image-display">
            <img src='https://images.pexels.com/photos/546819/pexels-photo-546819.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260' alt="POKE-CSS-LOGO" className="wrapped-image" />

        </div>
    </div>
}

export default Image